import { useMemo } from "react";
import { RecipeResult } from "../../../../api/recipeResults";
import { Recipe } from "../../../../api/recipeSimulator";
import { VariantImpactRow } from "../recipeImpactChart.types";

/**
 * Derives the rows shown in the variation table: one per variant that exists in
 * both the calculated results and the recipe definition. Memoised so the table
 * only re-renders when the underlying data actually changes.
 */
export const useRecipeVariantData = (
  recipeResults: RecipeResult | undefined,
  originalRecipeData: Recipe | null
): VariantImpactRow[] =>
  useMemo(() => {
    if (!recipeResults?.variantstotalImpacts || !originalRecipeData?.variants?.length) return [];

    const validNames = new Set(originalRecipeData.variants.map(variant => variant.variantName));

    return recipeResults.variantstotalImpacts
      .filter(variant => validNames.has(variant.variantName))
      .map(variant => ({
        id: variant._id,
        variantName: variant.variantName,
        climateImpact: variant.totalImpacts?.climateChange?.measure ?? 0
      }));
  }, [recipeResults, originalRecipeData]);
